/* The Talia's tabs — `canvas.css` `.t2-tabs` / `.t2-tab`: equal boxes in one row, the chosen one on
 * the card's ground with a stronger edge. The tab box itself is `TabStrip`'s `cards` skin; this is
 * the bar and what stands inside a tab.
 *
 * Text that must be read is `--text-2` where the canon writes `--text-3`: `--text-3` measures 3.0:1
 * (Flame) and 4.0:1 (Flame Dark) on these surfaces — the standing deviation `DetailTab.module.css`
 * records, kept by the 31.08 decision on a measured contrast number. */

.bar {
  margin-block-end: var(--space-10px);
}

.label {
  display: flex;
  gap: var(--space-10px);
  align-items: center;
  min-width: 0;
}

.words {
  display: flex;
  flex-direction: column;
  min-width: 0;
  text-align: start;
}

.kind {
  overflow: hidden;
  font-size: var(--fs-label);
  font-weight: var(--fw-bold);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.value {
  font-size: var(--fs-button);
  font-weight: var(--fw-extrabold);
  letter-spacing: var(--ls-title);
  font-variant-numeric: tabular-nums;
  color: var(--text);
}

.danger {
  color: var(--danger);
}

.small {
  font-size: var(--fs-label);
  font-weight: var(--fw-bold);
  color: var(--text-2);
}
